import { render, staticRenderFns } from "./ModelButton.vue?vue&type=template&id=f22ce902&scoped=true"
import script from "./ModelButton.vue?vue&type=script&lang=js"
export * from "./ModelButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f22ce902",
  null
  
)

export default component.exports